// import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

export default {
  async install(Vue, store) {
    if (!process.env.VUE_APP_PUSHER_APP_KEY) {
      Vue.prototype.$pusherjs = {}
      return;
    }

    let token = await store.getters['oauth2/accessToken']

    Vue.prototype.$pusherjs = new Pusher(process.env.VUE_APP_PUSHER_APP_KEY, {
      cluster: 'ap2',
      authEndpoint: process.env.VUE_APP_BASE_API_URL + '/broadcasting/auth',
      auth: {
        headers: {
          Authorization: 'Bearer ' + token
        },
      },
    });
  }
}